module.exports = __webpack_public_path__ + "img/business-center.f4178ea4.svg";